import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { BrowserRouter as Router } from 'react-router-dom';
import { refreshCallsAuth, bindCallListeners } from './calls';

window.store = store;
if ("Notification" in window && Notification.permission !== "granted") {
  Notification.requestPermission();
}
// 🔇 Глушим Future Flag Warning от React Router
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('React Router Future Flag Warning')) return;
    originalWarn(...args);
  };
}

// 1) Свяжем CallService с Redux (один раз на всё приложение)
refreshCallsAuth();
bindCallListeners(store.dispatch, store.getState);


ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);
